import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { deleteFromS3 } from '../../lib/s3'

const deleteMusicSchema = z.object({
  id: z.string().min(1),
})

/**
 * Delete a music by id
 */
export const deleteMusic = createServerFn({ method: 'POST' })
  .inputValidator(deleteMusicSchema)
  .handler(async (ctx): Promise<{ success: boolean }> => {
    const { id } = ctx.data
    try {
      await deleteFromS3(`music/${id}.json`)
      return { success: true }
    } catch (error: any) {
      throw new Error(error.message || 'Failed to delete Music')
    }
  })
